module.exports = __webpack_public_path__ + "img/checked_green.38699533.svg";